import React from "react"
import { Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router"
import { TrackerSelectList } from "./TrackerSelectList"
import { useTrackerSelectList } from "./useTrackerSelectList"

export const FleetTrackerSelectTab: React.FC = () => {
  const { t } = useTranslation()
  const { partnerUuid, fleetUuid } = useParams()
  const allTrackersList = useTrackerSelectList(partnerUuid, fleetUuid, "exclude")
  const fleetTrackersList = useTrackerSelectList(partnerUuid, fleetUuid, "include")
  return (
    <Row>
      <Col md>
        <TrackerSelectList
          title={t("settings.partner.available_trackers")}
          listType="select"
          searchText={allTrackersList.searchText}
          loadingItemIds={allTrackersList.loadingItemIds}
          trackerList={allTrackersList.trackerList}
          activePage={allTrackersList.activePage}
          totalPages={allTrackersList.totalPages}
          trackerCount={allTrackersList.trackerCount}
          listLoading={allTrackersList.refreshLoading}
          onSearchChange={allTrackersList.onSearchChange}
          onPageChange={allTrackersList.onPageChange}
          onItemPress={allTrackersList.onItemPress(fleetTrackersList.refresh)}
        />
      </Col>
      <Col md>
        <TrackerSelectList
          title={t("settings.partner.assigned_trackers")}
          listType="deselect"
          searchText={fleetTrackersList.searchText}
          loadingItemIds={fleetTrackersList.loadingItemIds}
          trackerList={fleetTrackersList.trackerList}
          activePage={fleetTrackersList.activePage}
          totalPages={fleetTrackersList.totalPages}
          trackerCount={fleetTrackersList.trackerCount}
          listLoading={fleetTrackersList.refreshLoading}
          onSearchChange={fleetTrackersList.onSearchChange}
          onPageChange={fleetTrackersList.onPageChange}
          onItemPress={fleetTrackersList.onItemPress(allTrackersList.refresh)}
        />
      </Col>
    </Row>
  )
}
